import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    marginTop: 33.1,
    alignItems: 'center',
    marginHorizontal: 16.5,
  },
  title: {
    marginBottom: 16.1,
    fontSize: 20.8,
    ...Fonts.type.bold,
    lineHeight: 29.1,
  },
  description: {
    fontSize: 18.7,
    lineHeight: 25,
    textAlign: 'center',
    paddingHorizontal: 16.5,
  },
});
